import { render, staticRenderFns } from "./TBox.vue?vue&type=template&id=33633245&scoped=true&"
import script from "./TBox.vue?vue&type=script&lang=js&"
export * from "./TBox.vue?vue&type=script&lang=js&"
import style0 from "./TBox.vue?vue&type=style&index=0&id=33633245&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33633245",
  null
  
)

export default component.exports